import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export interface Breadcrumb {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Breadcrumb[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-500 mb-4">
      {items.map((item, index) => (
        <div key={item.path || index} className="flex items-center">
          {index > 0 && <ChevronRight size={16} className="mx-2" />}
          {item.path ? (
            <Link
              to={item.path}
              className="hover:text-blue-600 hover:underline"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-900">{item.label}</span>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
